import React, { useState, useEffect } from 'react';

function AppearanceSection() {
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'system');

  useEffect(() => {
    const applyTheme = (value) => {
      if (value === 'system') {
        const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
        document.documentElement.setAttribute('data-theme', prefersDark ? 'dark' : 'light');
      } else {
        document.documentElement.setAttribute('data-theme', value);
      }
    };
    applyTheme(theme);
  }, [theme]);

  const handleThemeChange = (value) => {
    setTheme(value);
    localStorage.setItem('theme', value);
    // App.js Theme-State synchronisieren via CustomEvent
    window.dispatchEvent(new CustomEvent('theme-change', { detail: value }));
  };

  return (
    <>
      <section className="settings-section">
        <h3 className="settings-section-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
          </svg>
          Erscheinungsbild
        </h3>
        <p className="settings-desc">
          Wähle zwischen hellem und dunklem Modus oder folge den Systemeinstellungen.
        </p>
        <div className="settings-theme-picker">
          {[
            { value: 'light', label: 'Hell', icon: '☀️' },
            { value: 'dark', label: 'Dunkel', icon: '🌙' },
            { value: 'system', label: 'System', icon: '💻' },
          ].map(opt => (
            <button
              key={opt.value}
              className={`settings-theme-option${theme === opt.value ? ' active' : ''}`}
              onClick={() => handleThemeChange(opt.value)}
            >
              <span className="settings-theme-option-icon">{opt.icon}</span>
              <span className="settings-theme-option-label">{opt.label}</span>
            </button>
          ))}
        </div>
      </section>

      <section className="settings-section settings-section-divider">
        <p className="settings-desc" style={{ margin: 0, fontStyle: 'italic' }}>
          Weitere Optionen wie Schriftgröße und Editor-Breite folgen in einer zukünftigen Version.
        </p>
      </section>
    </>
  );
}

export default AppearanceSection;
